var _rect, _rect2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgClose = function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.687,
    y: 0.636,
    width: 16,
    height: 2,
    rx: 1,
    transform: "rotate(45 1.687 .636)",
    fill: "#17294D"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.272,
    y: 11.95,
    width: 16,
    height: 2,
    rx: 1,
    transform: "rotate(-45 .272 11.95)",
    fill: "#17294D"
  })));
};

export { SvgClose as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTMiIGhlaWdodD0iMTQiIHZpZXdCb3g9IjAgMCAxMyAxNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iMS42ODY1MiIgeT0iMC42MzU5ODYiIHdpZHRoPSIxNiIgaGVpZ2h0PSIyIiByeD0iMSIgdHJhbnNmb3JtPSJyb3RhdGUoNDUgMS42ODY1MiAwLjYzNTk4NikiIGZpbGw9IiMxNzI5NEQiLz4KPHJlY3QgeD0iMC4yNzI0NjEiIHk9IjExLjk0OTciIHdpZHRoPSIxNiIgaGVpZ2h0PSIyIiByeD0iMSIgdHJhbnNmb3JtPSJyb3RhdGUoLTQ1IDAuMjcyNDYxIDExLjk0OTcpIiBmaWxsPSIjMTcyOTREIi8+Cjwvc3ZnPgo=";